<p-paginator
  (onPageChange)="onPageChange($event)"
  [first]="page"
  [rows]="rows"
  [totalRecords]="totalRecords"
  styleClass="bg-transparent"
></p-paginator>
